(function(){
'use strict';
if(window.NoveraliI18n&&window.NoveraliI18n.version)return;
function initializeNoveraliI18n(){
if(window.NoveraliI18n&&window.NoveraliI18n.version)return;
var DATA=window.NoveraliI18nData||{sources:[],packs:{},away:{}};
var SOURCES=DATA.sources||[],PACKS=DATA.packs||{},AWAY=DATA.away||{};
function resolveLocale(raw){
  var value=String(raw||'en').replace('_','-'),lower=value.toLowerCase();
  if(lower==='pt'||lower.indexOf('pt-')===0)return 'pt-BR';
  if(lower==='zh-tw'||lower==='zh-hant'||lower.indexOf('zh-hant-')===0)return 'zh-TW';
  if(lower==='no'||lower==='nn'||lower.indexOf('nb-')===0)return 'nb';
  var base=lower.split('-')[0],keys=Object.keys(PACKS);
  for(var i=0;i<keys.length;i++)if(keys[i].toLowerCase()===lower)return keys[i];
  for(var j=0;j<keys.length;j++)if(keys[j].toLowerCase()===base)return keys[j];
  return 'en';
}
var locale=resolveLocale(document.documentElement.lang||(window.Shopify&&Shopify.locale)||'en');
function norm(value){
  return String(value==null?'':value).replace(/\s+/g,' ').trim().toLocaleLowerCase('en');
}
function fixLegacyBrand(value){
  return String(value==null?'':value)
    .replace(/support@nivaleshop\.com/gi,'support@nexolens.site')
    .replace(/support@noverali\.com/gi,'support@nexolens.site')
    .replace(/nivaleshop\.com/gi,'nexolens.site')
    .replace(/noverali\.com/gi,'nexolens.site')
    .replace(/Nivalé/gi,'Nexolens')
    .replace(/Novareli/gi,'Nexolens')
    .replace(/Noverali/gi,'Nexolens');
}
var map=Object.create(null);
if(PACKS[locale])SOURCES.forEach(function(source,index){
  var target=PACKS[locale][index];
  if(target!=null&&target!=='')map[norm(fixLegacyBrand(source))]=fixLegacyBrand(target);
});
function escapeRegExp(value){return value.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');}
var embeddedSources=PACKS[locale]?SOURCES.map(fixLegacyBrand).filter(function(source){
  return source.length>=8&&
    source.indexOf('[')===-1&&
    source.indexOf('xxxx')===-1&&
    source.indexOf('{value}')===-1;
}).sort(function(a,b){return b.length-a.length;}):[];
var embeddedRegex=null;
if(embeddedSources.length){
  try{
    embeddedRegex=new RegExp(embeddedSources.map(function(source){
      return escapeRegExp(source).replace(/\s+/g,'\\s+');
    }).join('|'),'gi');
  }catch(error){embeddedRegex=null;}
}
function targetTemplate(source,token){
  var target=map[norm(source)];
  return target?target.replace(token,'{value}'):null;
}
var dynamicTemplates={
  sold:targetTemplate('{value} sold','{value}'),
  buy:targetTemplate('Buy [quantity]','[quantity]'),
  save:targetTemplate('You save [amount_saved]','[amount_saved]'),
  savePercent:targetTemplate('Save [percentage]','[percentage]'),
  cartCount:targetTemplate('Your cart ([count])','[count]'),
  cartReserved:targetTemplate('Cart reserved for [timer] more minutes!','[timer]'),
  spendMore:targetTemplate('Spend [amount] more to get FREE shipping!','[amount]'),
  productsReserved:targetTemplate('Your products are reserved for [timer] minutes!','[timer]'),
  reviews:targetTemplate('(xxxx Reviews)','xxxx'),
  offerExpires:targetTemplate('Hurry! Offer expires in [timer] ⏰','[timer]')
};
function applyTemplate(template,value){return template?template.replace('{value}',value):null;}
function translatePattern(raw){
  var m;
  /*
   * Bundle apps sometimes partially translate the static text themselves and
   * leave a mixed-language sentence. Matching the live clock and alarm icon
   * lets us replace the complete sentence on every timer update.
   */
  m=raw.match(/(\d{1,2}:\d{2})\s*⏰\s*$/u);
  if(m&&raw.length<=140&&dynamicTemplates.offerExpires){
    return applyTemplate(dynamicTemplates.offerExpires,m[1]);
  }
  m=raw.match(/^([\d.,\s]+)\s+sold$/i);
  if(m&&dynamicTemplates.sold)return applyTemplate(dynamicTemplates.sold,m[1]);
  m=raw.match(/^Buy\s+(\d+)$/i);
  if(m&&dynamicTemplates.buy)return applyTemplate(dynamicTemplates.buy,m[1]);
  m=raw.match(/^You\s+save\s+(.+)$/i);
  if(m&&dynamicTemplates.save)return applyTemplate(dynamicTemplates.save,m[1]);
  m=raw.match(/^Save\s+(.+)$/i);
  if(m&&dynamicTemplates.savePercent)return applyTemplate(dynamicTemplates.savePercent,m[1]);
  m=raw.match(/^Your\s+cart\s+\((\d+)\)$/i);
  if(m&&dynamicTemplates.cartCount)return applyTemplate(dynamicTemplates.cartCount,m[1]);
  m=raw.match(/^Cart\s+reserved\s+for\s+(.+?)\s+more\s+minutes!$/i);
  if(m&&dynamicTemplates.cartReserved)return applyTemplate(dynamicTemplates.cartReserved,m[1]);
  m=raw.match(/^Spend\s+(.+?)\s+more\s+to\s+get\s+FREE\s+shipping!$/i);
  if(m&&dynamicTemplates.spendMore)return applyTemplate(dynamicTemplates.spendMore,m[1]);
  m=raw.match(/^Your\s+products\s+are\s+reserved\s+for\s+(.+?)\s+minutes!$/i);
  if(m&&dynamicTemplates.productsReserved)return applyTemplate(dynamicTemplates.productsReserved,m[1]);
  m=raw.match(/^\(([\d.,\s]+)\s+Reviews\)$/i);
  if(m&&dynamicTemplates.reviews)return applyTemplate(dynamicTemplates.reviews,m[1]);
  return null;
}
function translate(value){
  var raw=fixLegacyBrand(value);
  if(!PACKS[locale]||!raw.trim())return raw;
  var hit=map[norm(raw)];
  if(hit)return hit;
  var patternHit=translatePattern(raw.trim());
  if(patternHit)return patternHit;
  var awayMatch=raw.trim().match(/^You're\s+(.+?)\s+away\s+from\s+FREE\s+shipping!$/i);
  if(awayMatch&&AWAY[locale])return AWAY[locale].replace('{amount}',awayMatch[1]);
  if(embeddedRegex)raw=raw.replace(embeddedRegex,function(match){
    return map[norm(match)]||match;
  });
  return raw;
}
function preserveWhitespace(original,replacement){
  var lead=(original.match(/^\s*/)||[''])[0],tail=(original.match(/\s*$/)||[''])[0];
  return lead+replacement+tail;
}
var blocked={SCRIPT:1,STYLE:1,NOSCRIPT:1,CODE:1,PRE:1,TEXTAREA:1,SVG:1};
var textAttrs=[
  'placeholder','aria-label','title','data-empty-text','data-loading-text',
  'data-text','data-day-labels','data-month-labels','data-warning-text',
  'data-message','data-label','data-title','data-caption','data-subtitle',
  'data-button-label','data-badge'
];
function canTranslateValue(el){
  if(!el||el.tagName!=='INPUT')return false;
  var type=String(el.getAttribute('type')||'text').toLowerCase();
  return type==='button'||type==='submit'||type==='reset';
}
function translateAttributes(el){
  if(!el.hasAttribute)return;
  textAttrs.forEach(function(attr){
    if(!el.hasAttribute(attr))return;
    var current=el.getAttribute(attr),next=translate(current);
    if(next!==current)el.setAttribute(attr,next);
  });
  if(el.hasAttribute('value')&&canTranslateValue(el)){
    var currentValue=el.getAttribute('value'),nextValue=translate(currentValue);
    if(nextValue!==currentValue)el.setAttribute('value',nextValue);
  }
}
function translateTextNode(node){
  var parent=node.parentElement;
  if(!parent||blocked[parent.tagName]||parent.closest('[data-noverali-i18n-skip]'))return;
  var current=node.nodeValue,next=translate(current);
  if(next!==current)node.nodeValue=preserveWhitespace(current,next);
}
function translateRoot(root){
  if(!root)return;
  if(root.nodeType===3){translateTextNode(root);return;}
  if(root.nodeType!==1&&root.nodeType!==9&&root.nodeType!==11)return;
  if(root.nodeType===1){
    if(blocked[root.tagName]||root.closest('[data-noverali-i18n-skip]'))return;
    translateAttributes(root);
  }
  var walker=document.createTreeWalker(root,NodeFilter.SHOW_ELEMENT|NodeFilter.SHOW_TEXT),node;
  while((node=walker.nextNode())){
    if(node.nodeType===3)translateTextNode(node);
    else if(!blocked[node.tagName])translateAttributes(node);
  }
}
var queue=[],scheduled=false;
function flush(){
  scheduled=false;
  var seen=[];
  queue.splice(0).forEach(function(node){
    if(seen.indexOf(node)!==-1)return;
    seen.push(node);
    translateRoot(node);
  });
}
function enqueue(node){
  if(!node)return;
  queue.push(node);
  if(!scheduled){
    scheduled=true;
    (window.requestAnimationFrame||function(cb){window.setTimeout(cb,16);})(flush);
  }
}
function start(){
  document.documentElement.setAttribute('data-noverali-locale',locale);
  translateRoot(document.body||document.documentElement);
  var observer=new MutationObserver(function(records){
    records.forEach(function(record){
      if(record.type==='characterData')enqueue(record.target);
      else if(record.type==='childList')record.addedNodes.forEach(enqueue);
      else if(record.type==='attributes')enqueue(record.target);
    });
  });
  observer.observe(document.documentElement,{
    childList:true,
    subtree:true,
    characterData:true,
    attributes:true,
    attributeFilter:textAttrs.concat(['value'])
  });
}
window.NoveraliI18n={
  version:'3.0.0',
  locale:locale,
  t:translate,
  translateRoot:translateRoot,
  refresh:function(){translateRoot(document.body||document.documentElement);}
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
document.addEventListener('shopify:section:load',function(e){enqueue(e.target);});
document.addEventListener('cart:updated',function(){enqueue(document.body);});
document.addEventListener('cart:refresh',function(){enqueue(document.body);});
document.addEventListener('variant:change',function(){enqueue(document.body);});
document.addEventListener('product:updated',function(){enqueue(document.body);});
document.addEventListener('kaching:bundle:render',function(){enqueue(document.body);});
document.addEventListener('bundle:updated',function(){enqueue(document.body);});
}
var ready=window.NoveraliI18nCompleteReady;
if(ready&&typeof ready.then==='function'){
  ready.then(initializeNoveraliI18n,initializeNoveraliI18n);
}else{
  initializeNoveraliI18n();
}
})();